import { PATHS } from '~/utils/constants';

export default {
  [PATHS.AQ]: {
    name: 'AQ'
  },
  [PATHS.PM]: {
    name: 'PM',
    unit: 'µg/m³',
    round: 0
  },
  [PATHS.PM1]: {
    name: 'PM1',
    unit: 'µg/m³',
    round: 0
  },
  [PATHS.PM10]: {
    name: 'PM10',
    round: 0,
    unit: 'µg/m³'
  },
  [PATHS.PM25]: {
    name: 'PM25',
    round: 0,
    unit: 'µg/m³'
  },
  [PATHS.CO2]: {
    name: 'CO₂',
    round: 0,
    unit: 'ppm'
  },
  [PATHS.VOC_ETOH]: {
    name: 'VOC (EtOH)',
    round: 2,
    unit: 'ppm'
  },
  [PATHS.VOC_ISOBUTYLENE]: {
    name: 'VOC (Isobutylene)',
    round: 2,
    unit: 'ppm'
  },
  [PATHS.CH2O]: {
    name: 'CH₂O',
    round: 3,
    unit: 'mg/m³'
  },
  [PATHS.HUMIDITY]: {
    name: 'Humidity',
    round: 0,
    unit: '%'
  },
  [PATHS.TEMPERATURE_F]: {
    name: 'Temperature',
    round: 1,
    unit: '°F'
  },
  [PATHS.TEMPERATURE_C]: {
    name: 'Temperature',
    round: 1,
    unit: '°C'
  },
  [PATHS.ONLINE]: {
    name: 'Status'
  },
  [PATHS.LOCATION]: {
    name: 'Location'
  },
  [PATHS.BATTERY_VOLTAGE]: {
    name: 'Batt. Voltage',
    unit: 'V',
    round: 1
  },
  [PATHS.NOISE_LEVEL]: {
    name: 'Noise Level',
    unit: 'dB',
    round: 0
  }
};
